import SocialMediasData from "../../Data/SocialMediasData";

const SocialMedia = () => {
    return (
        <div className="flex items-center gap-2">
            {SocialMediasData.map((socialMedia) => (
                <a
                    key={socialMedia.key}
                    href={socialMedia.Link}
                    rel="noreferrer"
                    target="_blank"
                    aria-label={`Visit ${socialMedia.Name}`}
                    className="flex items-center justify-center rounded-xl transition-all duration-200"
                    style={{
                        width: "40px",
                        height: "40px",
                        background: "rgba(255,255,255,0.05)",
                        border: "1px solid rgba(255,255,255,0.1)",
                        color: "rgba(255,255,255,0.55)",
                    }}
                    onMouseEnter={(e) => {
                        e.currentTarget.style.background = "rgba(200,151,42,0.1)";
                        e.currentTarget.style.borderColor = "rgba(200,151,42,0.3)";
                        e.currentTarget.style.color = "#C8972A";
                    }}
                    onMouseLeave={(e) => {
                        e.currentTarget.style.background = "rgba(255,255,255,0.05)";
                        e.currentTarget.style.borderColor = "rgba(255,255,255,0.1)";
                        e.currentTarget.style.color = "rgba(255,255,255,0.55)";
                    }}
                >
                    {socialMedia.Icon}
                </a>
            ))}
        </div>
    );
};

export default SocialMedia;
